import React from "react";
import { connect } from "react-redux";
import { createSelector } from "../components/common/orm";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Icon from "@mdi/react";
import { mdiUpload } from "@mdi/js";
import CircularProgress from "@material-ui/core/CircularProgress";

const waterYear = createSelector((session, id) => {
  let wy = session.WaterYear.filter(
    (y) => y.is_active === true
  ).toRefArray()[0];
  return {
    ...wy,
  };
});

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

const LOCAL_URL = "http://localhost:3000";
const PROD_URL = "https://dms2.houstoneng.net";

const styles = (theme) => ({
  buttons: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    marginRight: "15px",
    marginTop: "10px",
    marginBottom: "10px",
  },
  root: {
    display: "flex",
    "& > * + *": {
      marginLeft: 2,
    },
  },
  loading: {
    width: "20px !important",
    height: "20px !important",
  },
});

class ImportSubmitButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetching: false,
    };
  }

  render() {
    const { classes, data, dataTarget } = this.props;

    let isDisabled = false;

    let disabled =
      !data.cy_data.authorized_reporter ||
      (data.cy_data && !data.cy_data[dataTarget + "_ct"]) ||
      (data.cy_data && data.cy_data[dataTarget + "_submitted"] === "Complete");

    if (disabled) {
      isDisabled = true;
    } else if (this.state.isFetching) {
      isDisabled = true;
    } else if (!this.state.isFetching && !disabled) {
      isDisabled = false;
    }

    return (
      <Button
        className={classes.buttons}
        onClick={() => this.fetchData()}
        disabled={isDisabled}
        style={{
          backgroundColor: isDisabled ? "#7ed2f5" : "primary",
          color: "white",
        }}
      >
        {this.state.isFetching ? (
          <div className={classes.root}>
            <CircularProgress className={classes.loading} />
          </div>
        ) : (
          <Icon path={mdiUpload} size={1} color="white"></Icon>
        )}
        Submit as Final
      </Button>
    );
  }

  fetchData = () => {
    //options for apitarget: [reportingstatus,importstatus,combinedstatus]

    let URL = isLocalhost ? LOCAL_URL : PROD_URL;

    const { authState, water_year, dataTarget, gsp } = this.props;

    let token = authState && authState.user ? authState.user.auth_token : "";

    this.setState({ ...this.state, isFetching: true });

    let datasetname = "";

    switch (dataTarget) {
      case "gw":
        datasetname = "wellsitemeasurements";
        break;
      case "wq":
        datasetname = "waterqualitymeasurements";
        break;
      case "surf":
        datasetname = "surfacewatermeasurements";
        break;
      case "sub":
        datasetname = "subsidencemeasurements";
        break;
      case "gws":
        datasetname = "groundwaterstorage";
        break;
      case "gwe":
        datasetname = "groundwaterextraction";
        break;
      case "sws":
        datasetname = "surfacewatersupply";
        break;
      case "twu":
        datasetname = "totalwateruse";
        break;
      case "stream":
        datasetname = "streammonitoring";
        break;
      default:
        break;
    }

    let submitted =
      this.props.data.cy_data[dataTarget + "_submitted"] === "Complete" ? 0 : 1;

    let payload = {
      datasetname: datasetname,
      submitted: submitted,
      gsp_id: gsp,
      water_year: water_year.water_year,
    };

    fetch(URL + "/bulksubmit", {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Token " + token,
      },
    })
      .then((response) => response.json())
      .then((result) => {
        this.setState({ ...this.state, isFetching: false });
        this.props.handler(result);
      })
      .catch((e) => {
        console.log(e);
        this.setState({ ...this.state, isFetching: false });
      });
  };
}
ImportSubmitButton = connect(
  (state, ownProps) => ({
    water_year: waterYear(state, ownProps),
    authState: state.auth,
  }),
  {}
)(ImportSubmitButton);

export default withStyles(styles)(ImportSubmitButton);
